/**
 * True when the URL is under staff sections (sidebar layouts).
 * Keep in sync with staff route prefixes in routes.config.tsx.
 */
export const isStaffAreaPathname = (pathname: string): boolean => /^\/(manager|waiter|owner|admin)(\/|$)/.test(pathname)
